module.exports = __webpack_public_path__ + "img/logo-p-philips.48673f10.jpg";